<template>
  <div
    class="ui-dialog"
    :class="{
      'ui-dialog--no-padding': noPadding
    }"
  >
    <div
      class="ui-dialog_main"
      :class="{
        'ui-dialog_main--mobile-align-top': mobileContentAlign === 'top'
      }"
    >
      <div class="ui-dialog_header" v-if="!noHeader">
        <slot name="header">
          <div class="ui-dialog_picture" v-if="picture">
            <img :src="require(`@/assets/${picture}`)" alt="decorative picture" class="ui-dialog_picture-img">
          </div>

          <div class="ui-dialog_title" v-if="title">
            <span class="ui-dialog_title-text">{{title}}</span>
          </div>
        </slot>
      </div>

      <div class="ui-dialog_content">
        <slot></slot>
      </div>
    </div>

    <div class="ui-dialog_actions" v-if="!isActionsEmpty">
      <slot name="actions">
      </slot>
    </div>

    <div class="ui-dialog_close-wrapper">
      <v-btn
        plain
        icon
        class="ui-dialog_close-btn"
        @click="$emit(`close`)"
      >
        <v-icon>$cross</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ui-dialog',

  props: {
    title: {
      type: String,
      default: null,
    },
    picture: {
      type: String,
      default: ``,
    },
    noHeader: {
      type: Boolean,
      default: false,
    },
    mobileContentAlign: {
      type: String,
      default: 'center'
    },
    noPadding: {
      type: Boolean,
      default: false,
    }
  },

  data: () => ({
    isActionsEmpty: true,
  }),

  mounted() {
    this.$nextTick(() => {
      this.isActionsEmpty = this.$slots.actions ? false : true
    })
  }
}
</script>

<style lang="sass">
.ui-dialog
  width: 100%
  min-height: 100px
  background-color: #fff
  padding: px-em(40) px-em(40) px-em(60)
  position: relative

  &--no-padding
    padding: 0

.ui-dialog_picture
  display: flex
  justify-content: center
  margin-bottom: 30px

.ui-dialog_header
  display: block
  margin-bottom: px-em(23)

.ui-dialog_title
  display: block
  text-align: center

.ui-dialog_title-text
  font-size: px-em(35)
  font-weight: 700
  color: #616161

.ui-dialog_content
  display: flex
  flex-direction: column
  align-items: center

.ui-dialog_text
  display: block
  text-align: center
  padding: 0
  margin: 0 0 px-em(15)

.v-application .ui-dialog_text
  margin: 0 0 px-em(15)

.ui-dialog_actions
  width: 100%
  display: flex
  align-items: center
  justify-content: center
  margin-top: px-em(30)

.ui-dialog_action
  + .ui-dialog_action
    margin-left: px-em(20)

.ui-dialog_close-wrapper
  position: absolute
  top: px-em(16)
  right: px-em(16)

.ui-dialog_close-btn
  font-size: px-em(18)

  &.v-btn--icon.v-size--default .v-icon
    font-size: inherit

@media screen and (max-width: $mobile-breakpoint)
  .ui-dialog
    min-height: 100%
    max-height: 100%
    overflow: hidden
    padding: 0
    display: flex
    flex-direction: column
    padding: px-em(50,16) px-em(30,16)
    overflow-y: auto

    &--no-padding
      padding: 0

  .ui-dialog_main
    margin-top: auto
    margin-bottom: auto

    &--mobile-align-top
      margin-top: 0

  .ui-dialog_title
    margin-bottom: 0
    font-size: px-em(16,12)

  .ui-dialog_icon
    position: static
    transform: none
    margin-bottom: px-em(20)

  .ui-dialog_content
    display: flex
    flex-direction: column

  .ui-dialog_actions
    flex-direction: column
    justify-content: flex-start
    // padding: px-em(20) px-em(10)

  .ui-dialog_action
    width: 100%

    + .ui-dialog_action
      margin-left: 0
      padding-top: px-em(10)
</style>
